module.exports = __webpack_public_path__ + "img/enToAm.760ff950.png";